import React from 'react';
import config from '../../config';

class CleverCallback extends React.Component {
  constructor(props) {
    const clientId = config.clientId//"YOUR_COGNITO_APP_CLIENT_ID";
    const redirectUri = encodeURIComponent(config.redirectUri);
    const domain = config.cognitoDomain //+ "YOUR_COGNITO_DOMAIN.auth.us-east-1.amazoncognito.com";
    const cleverLoginUrl =
        `${domain}/oauth2/authorize` +
        `?response_type=code` +
        `&client_id=${clientId}` +
        `&redirect_uri=${redirectUri}` +
        `&identity_provider=clever` +   // IMPORTANT
        `&scope=openid+email+profile`;
    
    window.location.href = cleverLoginUrl;

  }

  render() {
    if (this.state.loading) return <div>Logging in...</div>;
    return null;
  }
}

export default CleverCallback;
